/*
 * The unread count, on the tab.
 *
 * An operator with the panel in a background tab had one way of being told that
 * a message had arrived: a sound, which the browser mutes on a tab it has never
 * been clicked in, and which says nothing about how much is waiting. The number
 * in the tab's title is readable from the taskbar, survives a muted tab, and is
 * the one place a person already looks when they are working in something else.
 *
 * The favicon gets a dot to go with it, drawn over the real icon rather than
 * replacing it - everything here is wrapped, because a browser that will not
 * give the canvas back must cost the panel nothing.
 */

const BASE_TITLE = typeof document !== 'undefined' ? document.title : '';

let shown = null;
let baseIcon = null;
let baseIconFailed = false;

function iconLink() {
    const links = document.querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]');
    return links.length > 0 ? links[links.length - 1] : null;
}

function originalHref(link) {
    /* the href as written in the page, before any dot was painted on it */
    return link.getAttribute('data-base-href') || link.getAttribute('href');
}

function paint(count) {
    const link = iconLink();
    if (!link || baseIconFailed) return;

    const base = originalHref(link);
    if (!base) return;

    link.setAttribute('data-base-href', base);

    if (count === 0) {
        link.setAttribute('href', base);
        return;
    }

    const draw = () => {
        try {
            const size = 64;
            const canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;

            const context = canvas.getContext('2d');
            if (!context) return;

            context.drawImage(baseIcon, 0, 0, size, size);

            /* bottom right, with a ring of the page's own ground so the dot
               holds its edge against whatever the icon has underneath it */
            const radius = size * 0.3;
            const centre = size - radius - 2;

            context.beginPath();
            context.arc(centre, centre, radius + 3, 0, Math.PI * 2);
            context.fillStyle = '#ffffff';
            context.fill();

            context.beginPath();
            context.arc(centre, centre, radius, 0, Math.PI * 2);
            context.fillStyle = '#e5484d';
            context.fill();

            link.setAttribute('href', canvas.toDataURL('image/png'));
        } catch (e) {
            baseIconFailed = true;
        }
    };

    if (baseIcon) {
        draw();
        return;
    }

    const image = new Image();
    image.onload = () => {
        baseIcon = image;
        draw();
    };
    image.onerror = () => {
        baseIconFailed = true;
    };
    image.src = base;
}

/** The number of unread messages waiting for this operator. 0 clears it. */
export function setUnreadBadge(count) {
    if (typeof document === 'undefined') return;

    const next = count > 0 ? count : 0;
    if (next === shown) return;
    shown = next;

    document.title = next > 0 ? '(' + next + ') ' + BASE_TITLE : BASE_TITLE;

    try {
        paint(next);
    } catch (e) {
        /* a tab with no icon to draw on is still a tab with a title */
    }
}



// WEBPACK FOOTER //
// ./src/utils/tabBadge.js